module.exports = __webpack_public_path__ + "static/media/money_light.92c42f37.svg";